"use client";

import { c as _c } from "react/compiler-runtime";
import { FirebaseProvider } from "@/providers/firebaseProvider";
import { QueryProvider } from "@/providers/queryProvider";
import { SnackbarProvider } from "../../providers/toastProvider";
import { EventProvider } from "./analytics-context";
import EnquiryFlowShell from "@/components/get-in-touch/EnquiryFlowShell";
import SurveySheet from "@/components/survey/SurveySheet";
export function Providers(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <EnquiryFlowShell />;
    t2 = <SurveySheet />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <QueryProvider><SnackbarProvider><FirebaseProvider><EventProvider>{children}{t1}{t2}</EventProvider></FirebaseProvider></SnackbarProvider></QueryProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}